module.exports = __webpack_public_path__ + "static/media/yellow-star.e776ce34.svg";